// extracted by mini-css-extract-plugin
module.exports = {"marginBottom":"FpxModal_marginBottom__24BDt","checkbox":"FpxModal_checkbox__2L7RE","amount":"FpxModal_amount__3y_6a"};